<template>
    <v-container class="reader">
        <v-row>
            <v-col>
                <span class="text-h5">Entity Tags</span>
            </v-col>
            <v-col>
                <div class="d-flex justify-center justify-md-end mb-2">
                    <v-btn :to="{ name: 'newTag' }" title="Create a new tag" color="success"
                        ><v-icon class="mr-2">mdi-plus</v-icon>New</v-btn
                    >
                </div>
            </v-col>
        </v-row>
        <v-data-table
            :headers="headers"
            :items="tags"
            :items-per-page="15"
            dense
            class="elevation-1"
            :footer-props="{
                showFirstLastPage: true,
                itemsPerPageOptions: [-1, 10, 15, 20, 25],
                firstIcon: 'mdi-arrow-collapse-left',
                lastIcon: 'mdi-arrow-collapse-right',
                prevIcon: 'mdi-minus',
                nextIcon: 'mdi-plus',
            }"
        >
            <template v-slot:[`item.text`]="{ item }">
                <router-link :to="{ name: 'editTag', params: { id: item.id } }" :title="item.text">
                    {{ item.text }}
                </router-link>
            </template>
            <template v-slot:[`item.entityTypes`]="{ item }">
                {{ item.entityTypes.join(', ') }}
            </template>
        </v-data-table>
    </v-container>
</template>
<script>
import api from '@/api'
export default {
    data() {
        return {
            isLoading: false,
            tags: [],
            headers: [
                {
                    text: 'Tag',
                    align: 'start',
                    value: 'text',
                    width: '50%',
                },
                { text: 'Entities', value: 'entitiesString', filterable: false, width: '25%' },
            ],
        }
    },
    mounted() {
        this.getTags()
    },
    methods: {
        getTags() {
            this.isLoading = true
            api.get('tags')
                .then(res => (this.tags = res))
                .finally(() => {
                    this.isLoading = false
                })
        },
    },
}
</script>
